/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Select from '@material-ui/core/Select';
import { VIS } from '@tmna-ct/ipapps-core-js';
import styles from './styles';
import {
  visGetEvents,
  visSubscribeEvents,
  visGetMetaDataEvents,
  visSetEvents,
} from '../../constants/index';

import { License } from '../../assets/license/index';

class VisServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vis: null,
      token: {},
      lastSubscription: '',
      getSelectedEvent: '',
      getEventValue: {},
      setSelectedEvent: '',
      setEventValue: {},
      desireValue: '',
      subscribeSelectedEvent: '',
      subscribeEventValue: {},
      metaDataSelectedEvent: '',
      metaDataEventValue: {},
      error: '',
    };
  }

  componentWillMount() {
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = () => {
      const { status, readyState, responseText } = xmlhttp;
      if(status === 200 && readyState === 4){
        this.setState({
          vis: new VIS(responseText),
        });
      }
    };
    xmlhttp.open("GET", License, true);
    xmlhttp.send();
  }

  openWs() {
    try {
      const { vis } = this.state;
      vis.connect();
    } catch ({ message }) {
      this.setState({ error: message });
    }
  }

  closeWs() {
    const { vis } = this.state;
    vis.dissconect();
    this.setState({ error: '' });
  }

  getEvent(eventName, type) {
    const { vis } = this.state;
    if (eventName !== '') {
      vis.process(type, this.getSuccessHandler, eventName);
    } else {
      vis.process(type, event => this.setState({ token: event }));
    }
  }

  getSuccessHandler = event => {
    const { action } = event;
    if (action === 'get') this.setState({ getEventValue: event });
    if (action === 'getMetadata') this.setState({ metaDataEventValue: event });
  };

  setEvent(eventName) {
    const { vis, desireValue } = this.state;
    vis.process(
      'set',
      event => {
        console.log(event);
        this.setState({ setEventValue: event });
      },
      eventName,
      desireValue,
    );
  }

  subscribe(eventName) {
    const { vis } = this.state;
    vis.process(
      'subscribe',
      event => {
        this.setState({
          lastSubscription: event.subscriptionId,
          subscribeEventValue: event,
        });
      },
      eventName,
    );
  }

  unsubscribe() {
    const { vis, lastSubscription } = this.state;
    vis.process('unsubscribe', event => console.log(event), lastSubscription);
    this.setState({
      subscribeEventValue: {},
    });
  }

  unsubscribeAll() {
    const { vis } = this.state;
    vis.process('unsubscribeAll', event => console.log(event));
  }

  render() {
    const {
      t,
      classes: {
        container,
        mainActions,
        mainBody,
        separation,
        bodySeparation,
        textArea,
        errorMessage,
        leftControl,
        disclaimer,
        textAreaSingle,
      },
    } = this.props;
    const {
      token,
      error,
      getSelectedEvent,
      getEventValue,
      setEventValue,
      setSelectedEvent,
      subscribeEventValue,
      subscribeSelectedEvent,
      metaDataEventValue,
      metaDataSelectedEvent,
      desireValue,
    } = this.state;
    const hasValue = obj => Object.keys(obj).length > 0;
    const { get } = visGetEvents;
    const { subscribe } = visSubscribeEvents;
    const { getMetaData } = visGetMetaDataEvents;
    const { set } = visSetEvents;
    return (
      <div className={container}>
        <h3 className={separation}>{t('screens.Vis.title1')}</h3>
        <p>{t('screens.Vis.controlsDescription')}</p>
        <p className={`${errorMessage} ${disclaimer}`}>{t('screens.Vis.disclaimer')}</p>

        <div className={mainActions}>
          <p>{t('screens.Vis.controlsDescription')}</p>
          <ButtonGroup className={separation} size="small" color="primary">
            <Button onClick={() => this.openWs()}>{t('screens.Vis.open')}</Button>
            <Button onClick={() => this.unsubscribeAll()}>{t('screens.Vis.unsubscribeAll')}</Button>
            <Button onClick={() => this.closeWs()}>{t('screens.Vis.close')}</Button>
          </ButtonGroup>
          {error !== '' ? <p className={errorMessage}>{error}</p> : null}
        </div>

        <div className={mainBody}>
          <div className={bodySeparation}>
            <p>{t('screens.Vis.tokenDescription')}</p>
            <Button
              className={separation}
              variant="contained"
              color="primary"
              onClick={() => this.getEvent('', 'getToken')}
            >
              {t('screens.Vis.getToken')}
            </Button>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              onClick={() => this.setState({ token: {} })}
            >
              {t('screens.Vis.clearToken')}
            </Button>
            {hasValue(token) ? (
              <TextareaAutosize
                className={textArea}
                aria-label="VIS Token"
                rowsMax={10}
                value={JSON.stringify(token, null, 2)}
                disabled
              />
            ) : null}
          </div>

          <div className={bodySeparation}>
            <p>{t('screens.Vis.getDescription')}</p>
            <Select
              native
              value={getSelectedEvent}
              onChange={event => this.setState({ getSelectedEvent: event.target.value })}
              inputProps={{
                id: 'get-vis-value',
              }}
            >
              <option value="" />
              {get.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.getEvent(getSelectedEvent, 'get')}
            >
              {t('screens.Vis.getValue')}
            </Button>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              onClick={() => this.setState({ getEventValue: {}, getSelectedEvent: '' })}
            >
              {' '}
              {t('screens.Vis.clearResult')}
            </Button>
            {hasValue(getEventValue) ? (
              <TextareaAutosize
                className={textArea}
                aria-label="VIS Get Event Value"
                rowsMax={10}
                value={JSON.stringify(getEventValue, null, 2)}
                disabled
              />
            ) : null}
          </div>

          <div className={bodySeparation}>
            <p>{t('screens.Vis.subscribeDescription')}</p>
            <Select
              native
              value={subscribeSelectedEvent}
              onChange={event => this.setState({ subscribeSelectedEvent: event.target.value })}
              inputProps={{
                id: 'subscribe-vis-value',
              }}
            >
              <option value="" />
              {subscribe.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.subscribe(subscribeSelectedEvent)}
            >
              {t('screens.Vis.subscibe')}
            </Button>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="secondary"
              onClick={() => this.unsubscribe()}
            >
              {t('screens.Vis.unsubscibe')}
            </Button>
            {hasValue(subscribeEventValue) ? (
              <TextareaAutosize
                className={textArea}
                rowsMax={10}
                value={JSON.stringify(subscribeEventValue, null, 2)}
                disabled
              />
            ) : null}
          </div>

          <div className={bodySeparation}>
            <p>{t('screens.Vis.metaDataDescription')}</p>
            <Select
              native
              value={metaDataSelectedEvent}
              onChange={event => this.setState({ metaDataSelectedEvent: event.target.value })}
              inputProps={{
                id: 'metaData-vis-value',
              }}
            >
              <option value="" />
              {getMetaData.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.getEvent(metaDataSelectedEvent, 'getMetadata')}
            >
              {t('screens.Vis.metaData')}
            </Button>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              onClick={() => this.setState({ metaDataEventValue: {}, metaDataSelectedEvent: '' })}
            >
              {t('screens.Vis.clearResult')}
            </Button>

            {hasValue(metaDataEventValue) ? (
              <TextareaAutosize
                className={textArea}
                rowsMax={10}
                value={JSON.stringify(metaDataEventValue, null, 2)}
                disabled
              />
            ) : null}
          </div>

          <div className={bodySeparation}>
            <p>{t('screens.Vis.setDescription')}</p>
            <Select
              native
              value={setSelectedEvent}
              onChange={event => this.setState({ setSelectedEvent: event.target.value })}
              inputProps={{
                id: 'set-vis-value',
              }}
            >
              <option value="" />
              {set.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.setEvent(setSelectedEvent)}
            >
              {t('screens.Vis.setValue')}
            </Button>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              onClick={() =>
                this.setState({ setEventValue: {}, setSelectedEvent: '', desireValue: '' })
              }
            >
              {t('screens.Vis.clearResult')}
            </Button>
            <TextField
              id="set-value"
              label="VIS Set Value"
              className={textAreaSingle}
              value={desireValue}
              onChange={event => {
                this.setState({ desireValue: event.target.value });
              }}
              helperText="Type a value to send it to VIS"
              margin="normal"
            />
            {hasValue(setEventValue) ? (
              <TextareaAutosize
                className={textArea}
                rowsMax={10}
                value={JSON.stringify(setEventValue, null, 2)}
                disabled
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

VisServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(VisServices));
